import React, { ReactNode, useCallback, useMemo, useState } from 'react';
import { InProgressEstimates } from './Components/InProgressEstimates/InProgressEstimates';
import { InDraftEstimates } from './Components/InDraftEstimates/InDraftEstimates';
import { useSelector } from 'react-redux';
import { DashboardEstimate, EstimatesStatus } from '../../types/dashboardInformation';

export const useEstimatesBlock = () => {
    //@ts-ignore
    const { estimates, is_customer } = useSelector((state) => state.dashboardReducer);
    const inProgressEstimates = estimates.estimates.filter(
        (estimate: DashboardEstimate) =>
            estimate.status === EstimatesStatus.IN_EXPLOITATIONS ||
            estimate.status === EstimatesStatus.COMPLETED
    );
    const [activeTab, setActiveTab] = useState(() => {
        if (inProgressEstimates.length === 0) {
            return 'inDraft';
        }
        return 'inProgress';
    });
    const tabsContentMapping: Record<string, ReactNode> = useMemo(
        () => ({
            inProgress: <InProgressEstimates activeTab={activeTab} />,
            inDraft: <InDraftEstimates activeTab={activeTab} />,
        }),
        [activeTab]
    );
    const tabsList = useMemo(
        () => [
            {
                title: i18next.t('useEstimatesBlock.return.tabsList.title.inProgress'),
                value: 'inProgress',
            },
            {
                title: `${
                    is_customer
                        ? i18next.t('useEstimatesBlock.return.tabsList.title.onApproval')
                        : i18next.t('useEstimatesBlock.return.tabsList.title.inDraft')
                }`,
                value: 'inDraft',
            },
        ],
        [is_customer]
    );

    const onTabChange = useCallback((value: string) => {
        setActiveTab(value);
    }, []);

    return { activeTab, tabsList, tabsContentMapping, onTabChange };
};
